module.exports = __webpack_public_path__ + "img/2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vblModal/example/2.jpg
// module id = 184
// module chunks = 0